import React, { useState } from 'react';
import axios from 'axios';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from 'react-router-dom';

const ApiButton = ({ rollNumbers,centerCode }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleButtonClick = async () => {
        const requestBody = {
            examName: "DEMO",
            centerCode: centerCode,
            shift: '1',
            rollNumbers: rollNumbers,
        };

        try {
            const response = await axios.post(
                'https://croireatpl.in/api//students-by-roll-numbers',
                requestBody,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            setData(response.data);
            setError(null);
            navigate('/data-table', { state: { data: response.data } });
        } catch (err) {
            setError('Error: ' + err.message);
            setData(null);
        }
    };

    return (
        <div>
            <button onClick={handleButtonClick}>
                <WarningAmberIcon sx={{ color: "#ffa500" }} />
            </button>

            <div>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>
        </div>
    );
};

export default ApiButton;
